import { Component, Input, OnInit } from '@angular/core';
import Product from 'src/app/model/product/product';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import Board from 'src/app/model/product/board/board';
import { FileHelper } from '../../../helpers/file-helper';

@Component({
  selector: './adjustment-board-summary',
  templateUrl: './adjustment-board-summary.component.html',
  styleUrls: ['./adjustment-board-summary.component.scss'],
})
export class AdjustmentBoardSummaryComponent implements OnInit {
  @Input()
  product: Product;

  @Input()
  index: number;

  @Input()
  multipleProducts: boolean;

  board: Board;

  init = false;

  isImage = FileHelper.isImage;

  ngOnInit() {
    this.board = <Windowsticker>this.product;
    this.init = true;
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 8 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }
}
